import React, { FC, PropsWithChildren } from "react";
import cn from "classnames";

import "./index.scss";

interface Props extends PropsWithChildren {
  className?: string;
}
export const Section: FC<Props> = ({ children, className }) => {
  return <div className={cn("page-section", className)}>{children}</div>;
};
